import { BaseIconProps } from "../../types/styles";

const CoronalViewIcon = ({
    id,
    className,
    size = 29,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--color-white)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-coronal"}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 29 29"
            fill="none"
        >
            <path
                d="M1 19L14.3333 27.6667L14.3333 19L7.66667 14.3333L1 19Z"
                fill={color}
            />
            <path d="M1 9.66667V19L7.66667 14.3333L1 9.66667Z" fill={color} />
            <path
                d="M1 9.66667V19L14.3333 27.6667L27.6667 19V9.66667L14.3333 1L1 9.66667ZM27.6667 9.66667L14.3333 19M14.3333 27.6667L14.3333 19M1 19L7.66667 14.3333M1 9.66667L14.3333 19M14.3333 19L7.66667 14.3333L1 9.66667"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CoronalViewIcon;
